/**
 * Rounds the Judge.me preview badge average rating to one decimal place
 * (e.g. "4.79" -> "4.8") by overwriting the widget's own `data-score`
 * attribute on `.jdgm-prev-badge__stars` in place.
 *
 * This deliberately reuses the existing `data-score` attribute rather than
 * introducing a new one, so the Judge.me app's "Preview Badge > Custom CSS"
 * rule (`content: attr(data-score)`) keeps working unchanged and doesn't
 * depend on Judge.me's settings cache picking up a different attribute name.
 *
 * A MutationObserver keeps this in sync in case Judge.me re-renders the
 * badge later (e.g. after ratings load asynchronously or a variant change).
 * The write is idempotent (rounding an already-rounded value is a no-op),
 * so it does not loop even though it also observes `data-score` changes.
 */
(function () {
  function roundJdgmScore(el) {
    var raw = el.getAttribute('data-score');
    if (raw === null) return;
    var score = parseFloat(raw);
    if (isNaN(score)) return;
    var rounded = score.toFixed(1);
    if (raw !== rounded) {
      el.setAttribute('data-score', rounded);
    }
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches && root.matches('.jdgm-prev-badge__stars[data-score]')) {
      roundJdgmScore(root);
    }
    if (root.querySelectorAll) {
      root
        .querySelectorAll('.jdgm-prev-badge__stars[data-score]')
        .forEach(roundJdgmScore);
    }
  }

  scan(document.documentElement);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(scan);
      if (mutation.type === 'attributes') {
        scan(mutation.target);
      }
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-score'],
  });
})();
